import React from 'react';

export default function FormInput({ label, style, ...props }) {
  return (
    <div style={{ marginBottom: 16, ...style }}>
      {label && (
        <label
          style={{
            display: 'block',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--text-muted)',
            marginBottom: 5,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          }}
        >
          {label}
        </label>
      )}
      <input
        style={{
          width: '100%',
          padding: '10px 14px',
          border: '1.5px solid var(--border)',
          borderRadius: 'var(--radius-xs)',
          fontFamily: 'var(--font)',
          fontSize: '0.88rem',
          color: 'var(--text)',
          background: 'var(--surface)',
          outline: 'none',
          transition: 'all 0.2s',
        }}
        {...props}
      />
    </div>
  );
}